<template>
  <div class="p-6 ml-64 min-h-screen flex flex-col overflow-hidden">
    <SpinnerComp v-if="loading" :fullscreen="true" />

    <div v-else>
      <!-- Título -->
      <div>
        <h1 class="text-[#1E5D22] font-semibold text-3xl mb-2 ml-8 mt-5">
          Venta No. {{ venta[0] }}
        </h1>
        <p class="text-[#817F7F] text-xl ml-8">
          {{ operador[0] }}
        </p>
      </div>

      <!-- Info -->
      <div class="flex justify-between gap-4 px-4 py-2 mt-8 ml-4 mr-4">
        <div
          class="flex gap-1 bg-white border border-[#969292]/30 rounded-xl text-lg px-4 py-2"
        >
          <p class="text-[#817F7F] font-semibold mr-1">Cliente:</p>
          <p class="text-black">{{ cliente[0] }}</p>
        </div>

        <div
          class="flex gap-1 bg-white border border-[#969292]/30 rounded-xl text-lg px-4 py-2"
        >
          <p class="text-[#817F7F] font-semibold mr-1">Fecha:</p>
          <p class="text-black">{{ fecha[0] }}</p>
        </div>
      </div>


      <!-- Tabla -->
      <TableComp
        class="w-[1160px] ml-8 mt-9"
        :headers="['Producto', 'Cantidad', 'Total', 'Comision', 'Acciones']"
        :rows="productos"
        :visibleColumnsMobile="[0, 1]"
        :columnWidths="['35%', '15%', '15%', '9%', '10%']"
        total-label="Comisión"
        :total-amount="Comisiontotal"
      >
        <!-- Botón eliminar -->
        <template #cell-Acciones="{ row }">
          <button
            class="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded-lg text-sm"
            @click="abrirModalEliminar(row)"
          >
            Eliminar
          </button>
        </template>
      </TableComp>

      <div class="flex justify-center mt-8">
        <button
          class="bg-red-600 text-white rounded-xl p-3"
          @click="abrirModalCancelarVenta"
        >
          Cancelar Venta
        </button>
      </div>
    </div>

    <!-- Modal dinámico -->
    <div
      v-if="showModal"
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
    >
      <div class="bg-white rounded-xl p-6 w-[400px]">
        <h2 class="text-xl font-semibold mb-4 text-red-600">
          {{
            modalType === "deleteProduct"
              ? "Eliminar producto"
              : "Cancelar venta"
          }}
        </h2>

        <p class="text-gray-700 mb-6">
          <template v-if="modalType === 'deleteProduct'">
            ¿Estás seguro de eliminar el producto
            <span class="font-semibold">
              {{ productoSeleccionado?.Producto }} </span
            >?
          </template>

          <template v-else>
            ¿Estás seguro de cancelar la venta
            <span class="font-semibold"> No. {{ venta[0] }} </span>?
          </template>
        </p>

        <div class="flex justify-end gap-3">
          <button class="px-4 py-2 rounded-lg border" @click="cerrarModal">
            Cancelar
          </button>

          <button
            class="px-4 py-2 rounded-lg bg-red-600 text-white"
            @click="confirmarAccion"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComp from "@/components/TableComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";

export default {
  components: {
    TableComp,
    SpinnerComp,
  },

  data() {
    return {
      operador: [],
      venta: [],
      cliente: [],
      fecha: [],
      productos: [],
      Comisiontotal: 0,
      loading: true,

      showModal: false,
      modalType: null,
      productoSeleccionado: null,
    };
  },

  mounted() {
    const id = this.$route.params.id;

    this.$axios
      .get(`getSalesDetails/${id}`)
      .then((response) => {
        this.operador = response.data.operador;
        this.venta = response.data.venta;
        this.fecha = response.data.fecha;
        this.cliente = response.data.cliente;

        this.productos = response.data.productos.map((item) => ({
          Producto: item.Producto,
          Cantidad: item.Cantidad,
          Total: item.Total,
          Comision: item.Comision,
          id: item.id,
        }));
        console.log(this.productos);
        this.Comisiontotal = response.data.totalComision;
        this.loading = false;
      })
        .catch((error) => {
          const { notify } = require("@/utils/notify");
          notify(error.response.data.message, { type: 'error' });
        });
  },

  methods: {
    abrirModalCancelarVenta() {
      this.modalType = "cancelSale";
      this.showModal = true;
    },
    abrirModalEliminar(producto) {
      console.log("Producto recibido:", producto);

      this.productoSeleccionado = producto;
      this.modalType = "deleteProduct";
      this.showModal = true;
    },

    cerrarModal() {
      this.showModal = false;
      this.modalType = null;
      this.productoSeleccionado = null;
    },

    confirmarAccion() {
      console.log("ModalType:", this.modalType);

      if (this.modalType === "deleteProduct") {
        console.log("Entrando a eliminarProducto");
        this.eliminarProducto();
      }

      if (this.modalType === "cancelSale") {
        console.log("Entrando a cancelarVenta");
        this.cancelarVenta();
      }
    },

    cancelarVenta() {
      const idVenta = this.venta[0];

      this.$axios
        .post(`deletesale/${idVenta}`)
        .then(() => {
          this.cerrarModal();
          console.log("Venta cancelada correctamente");
          this.$router.back();
        })
        .catch((error) => {
          const { notify } = require("@/utils/notify");
          notify(error.response?.data?.message || "Error al cancelar venta", { type: 'error' });
        });
    },

    eliminarProducto() {
      if (!this.productoSeleccionado) return;

      console.log("Eliminando:", this.productoSeleccionado.id);

      this.$axios
        .post(`/deleteproducts_sales`, {
          sale_id: this.venta[0], // id de la venta
          product_id: this.productoSeleccionado.id, // id del producto
        })
        .then((response) => {
          // Remover producto de la lista en el frontend
          this.productos = this.productos.filter(
            (p) => p.id !== this.productoSeleccionado.id,
          );

          this.cerrarModal();

          // Revisar si era el último producto
          if (response.data.ultimoProducto) {
            // Si era el último producto, volver a la página anterior
            this.$router.back();
          } else {
            console.log("Producto eliminado correctamente");
          }
        })
        .catch((error) => {
          console.log("ERROR AXIOS:", error);
          const { notify } = require("@/utils/notify");
          notify(error.response?.data?.message || "Error al eliminar producto", { type: 'error' });
        });
    },
  },
};
</script>
